// extracted by mini-css-extract-plugin
module.exports = {"listBox":"ResultList_listBox__2vHHs","list":"ResultList_list__1YqAC base-styles_whiteBox__EFz-f"};